<template>
	<div class="deal_index_box">
		<!-- 個人資訊》安全綁定 -->
		<div class="deal_title">
			<div>個人資訊<span>》</span>安全綁定</div>
			<div class="deal_hr">
				<div class="cut_off"></div>
			</div>
		</div>
		<!-- 内容 -->
		<div class="deal_content_box">
			<div class="deal_content_title" v-if="!paymentslue">安全綁定</div>
			<div class="deal_content " v-if="!paymentslue">
				<el-tabs class="deal_content_tab" v-model="activeName" @tab-click="handleClick">
					<el-tab-pane class="is-top is-active" label="google驗證器綁定" name="first">
						<!-- 訂單列表查詢 -->
						<el-form :model="runForm" ref="runForm" :rules="rules2" class="datetime_box" v-if="paymentsd" size="mini"
						 label-width="140px">
							<el-form-item :span="8" prop="secret" label="google驗證器秘钥:" :rules="[
								  { required: true, message: '请输入google驗證器秘钥', trigger: 'blur' },
								]">
								<el-input v-model="runForm.secret" maxlength="16" placeholder="大寫字母A-Z,2-7,輸入一個字符串長度為16的秘鑰" style="width: 40%;"></el-input>
							</el-form-item>
							<el-form-item prop="trader_password" label="交易密碼:" :rules="[
								  { required: true, message: '请输入交易密碼', trigger: 'blur' },
								]">
								<el-input v-model="runForm.trader_password" placeholder="" style="width: 40%;" maxlength="6" type="password"></el-input>
								<div class="p_cetent">預留資訊：<span>{{reserved}}</span></div>
							</el-form-item>
							<el-form-item class="paind_bottm_end">
								<el-col :span="16" class="button_cetent">
									<el-button type="danger" plain class="bottom_onew">返回</el-button>
									<el-button type="danger" class="bottom_two" @click="submitForm()">送出</el-button>
								</el-col>
							</el-form-item>
						</el-form>
						<!-- 修改成功 -->
						<div class=" div_hight_dedt" v-if="payment_success">
							<el-row>
								<el-col :span="6" :xs="8" class="list_tile_sed icon_phigt">
									<i class="el-icon-warning colro-red"></i><span>設定完成</span>
								</el-col>
							</el-row>

						</div>
						<!-- 綁定成功 -->
						<div v-if="paymentsdBD">
							<el-row>
								<el-col :md="6" :sm="12" class="list_cent ">
									<div class="p_cetent">google驗證器秘钥：<span>{{secretd==''?'暫無綁定':secretd}}</span></div>
								</el-col>
								<el-col :md="6" :sm="12" class="list_cent">
									<div class="p_cetent">預留資訊：<span>{{reserved}}</span></div>
								</el-col>
							</el-row>
							<el-row class="paind_bottm_end">
								<el-col :span="16" class="button_cetent">
									<el-button type="danger" plain class="bottom_onew">返回</el-button>
									<el-button type="danger" class="bottom_two" @click="paymentsa()">更綁</el-button>
								</el-col>
							</el-row>
						</div>
					</el-tab-pane>
					<el-tab-pane label="增強IP綁定" name="second" class="left_label ">
						<!-- 增強IP綁定 -->
						<el-row>
							<el-col :span="8" :xs="16" class="list_cent ">
								<div class="p_cetent">您目前ip：{{setip}} <span>您正在安全IP環境中</span></div>
							</el-col>
						</el-row>
						<!-- 新增ip -->
						<el-row class="paind_bottm_end  blick_deal">
							<el-col :span="2" :xs="5" class="list_hight_li ">
								<div class="text_ip">新增安全IP：</div>
							</el-col>
							<el-col :span="4" :xs="7" class="input_high ">
								<el-input v-model="ip"></el-input>
							</el-col>
							<el-col :span="4" :xs="7" class=" input_high ipuer_left input_left">
								<el-select v-model="name" placeholder="请选择指定員工">
									<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
									</el-option>
								</el-select>
							</el-col>
							<el-col :span="3" :xs="6" class="input_high button_cetent_seas ipuer_left ">
								<el-button type="danger" class="bottom_two" @click='jojnsubm()'>加入安全IP</el-button>
							</el-col>
						</el-row>
						<!-- 安全ip表單 -->
						<el-row class="paind_bottm_end">

							<div class="table_header back_corlor">
								<div class="table_paymenttype">安全IP</div>
								<div class="table_date">時間</div>
								<div class="table_merchantorder">新增者</div>
								<div class="table_paymentorder">指定員工</div>
								<div class="table_operation">
									操作
								</div>

							</div>
							<div class="table_content" v-for="(item,index) of tableData" :key="item.id">
								<div class="table_paymenttype">{{item.ip}}</div>
								<div class="table_date">{{item.time}}</div>
								<div class="table_merchantorder">{{item.name}}</div>
								<div class="table_paymentorder">{{item.designation}}</div>
								<div class="table_operation">
									<span class="delete_tab" @click="handleDelete(index, tableData,item.id)">删除</span>
								</div>
							</div>
						</el-row>
					</el-tab-pane>
				</el-tabs>
			</div>
			<div class="deal_content_title" v-if="paymentslue">更綁google驗證器</div>
			<div class="deal_content " v-if="paymentslue">
				<div class="datetime_box">
					<el-row class="paind_bottm_end">
						<el-col :span="5" :xs="8">
							<div class="right_col">
								<span class="list_span">*</span>google驗證器秘钥:
							</div>
						</el-col>
						<el-col :span="4" :xs="10" class="input_high p_cend">
							<span>{{secretd==''?'暫無綁定':secretd}}</span>
						</el-col>
						<el-col :span="5" :xs="8">
							<div class="pid_cetent">預留資訊：<span>{{reserved}}</span></div>
						</el-col>
					</el-row>
					<el-row class="paind_bottm_end">
						<el-col :span="5" :xs="8">
							<div class="right_col">
								<span class="list_span">*</span>原google驗證器秘钥:
							</div>
						</el-col>
						<el-col :span="6" :xs="10" class="input_high">
							<el-input v-model="secret"></el-input>
						</el-col>
					</el-row>
					<el-row class="paind_bottm_end">
						<el-col :span="5" :xs="8">
							<div class="right_col">
								<span class="list_span">*</span>您的<span class="list_span">交易</span>密碼：
							</div>
						</el-col>
						<el-col :span="6" :xs="10" class="input_high">
							<el-input v-model="trader_password_two" type="password"></el-input>
						</el-col>
						<el-col :span="6">
							<div class="right_col_left">忘記交易密碼</div>
						</el-col>

					</el-row>
					<el-row>
						<el-col :span="3" :xs="1" class="ides_onw">
							<div class="height-plde"></div>
						</el-col>
						<el-col :span="16" :xs="23" class=" icon_phigt list_tile_sed">
							<i class="el-icon-warning colro-red"></i><span>簡訊驗證碼將發送到綁定的手機<span>(091******87)</span>,
								收到驗證碼後請填入下方欄位</span>
							<el-button type="warning" class="bottn_warning" @click='axiosVerification()'>點擊發送驗證碼</el-button>
						</el-col>
					</el-row>
					<el-row class="paind_bottm_end">
						<el-col :span="5" :xs="8">
							<div class="right_col">
								<span class="list_span">*</span>簡訊驗證碼：
							</div>
						</el-col>
						<el-col :span="6" :xs="10" class="input_high">
							<el-input v-model="code"></el-input>
						</el-col>
						<el-col :span="6">
							<div class="right_col_left">沒有收到驗證碼？</div>
						</el-col>
					</el-row>
					<el-row class="paind_bottm_end">
						<el-col :span="5" :xs="8">
							<div class="right_col">
								<span class="list_span">*</span>google驗證器秘钥:
							</div>
						</el-col>
						<el-col :span="6" :xs="10" class="input_high">
							<el-input v-model="re_secret"></el-input>
						</el-col>
					</el-row>
					<el-row class="paind_bottm_end">
						<el-col :span="16" class="button_cetent">
							<el-button type="danger" plain class="bottom_onew">返回</el-button>
							<el-button type="danger" class="bottom_two" @click="submitip()">更綁</el-button>
						</el-col>
					</el-row>
				</div>
			</div>
		</div>
		<!-- deal_index_box -->
	</div>
</template>

<script>
	import axios from 'axios';
	export default {
		name: 'LoginDealIndex',
		data() {
			//驗證交易密碼
			let validatePassl = (rule, value, callback) => {
				if (this.Verification(value)) {
					this.$message({
						showClose: true,
						message: '只能是純數字',
						type: 'error',
						duration: 1000
					});
				} else {

					this.ruleForm.trader_password = value
					callback()
				}
			}
			//google驗證器ID
			let validatePassd = (rule, value, callback) => {
				if (this.vergoogletion(value)) {
					this.$message({
						showClose: true,
						message: '從大寫字母A-Z,2-7,輸入壹個字符串長度為16-128的秘鑰',
						type: 'error',
						duration: 1000
					});
				} else {

					this.ruleForm.secret = value
					callback()
				}
			}
			return {
				Deleteid: '',
				tableData: [],
				ip: '',
				name: '',
				options: [{
					value: '張三',
				}, {
					value: '李四'
				}, {
					value: '王五'
				}],
				message: '',
				timeto: 60,
				countTime: 60,
				re_secret: '',
				secretstde: '',
				code: '',
				secret: '',
				trader_password_two: '',
				reserved: '',
				secretd: '',
				paymentslue: false,
				runForm: {
					secret: '',
					trader_password: ''
				},
				rules2: {
					secret: [{
						validator: validatePassd,
						trigger: 'change'
					}],
					trader_password: [{
						validator: validatePassl,
						trigger: 'change'
					}],
				},
				setip: '',
				paymentsd: true,
				paymentsdBD: false,
				payment_success: false,
				activeName: "first",
				trader_password: '',
				// return
			}
		},
		methods: {
			// 刪除表單
			handleDelete(index, tableData, id) {
				tableData.splice(index, 1);
				this.Deleteid = id
				axios.get(this.$store.state.axiosipdel, {
					params: {
						id: this.Deleteid,
						action: 1,
						uid: this.$store.state.uid,
					}
				}).then((res) => {
					// console.log(res)
				})
			},
			// 点击发送短信验证
			axiosVerification() {
				axios.get(this.$store.state.axiosPhone, {
					params: {
						telnum: this.$store.state.telephone
					}
				}).then((res) => {
					this.status = res.data.status;
					this.message = res.data.message;
					// console.log(res.data);
					if (this.status) {
						this.message = res.data.message;
						this.disabledTF = true;
						this.ShowSucc = true;
						this.ShowError = false;
						this.verify = "已發送驗證碼";
						// 倒計時
						this.buttonText = this.timeto + "秒後，可再次發送";
						let count = setInterval(() => {
							this.timeto -= 1;
							this.buttonText = this.timeto + "秒後，可再次發送";
							if (this.timeto < 0) {
								clearInterval(count);
								this.buttonText = '發送驗證碼';
								this.timeto = this.countTime;
								this.disabledTF = false;
								return
							}
						}, 1000);
					} else {
						this.ShowSucc = false;
						this.ShowError = true;
						this.remind = "手機已存在，歡迎重新登入";
					}
				})
			},
			// FUN-輸入驗證碼-01
			clickVerification() {
				// 发送ajax；
				this.axiosVerification();
			},
			handleClick(tab, event) {
				// console.log(tab, event);
			},
			paymentsa() {
				this.paymentslue = true;
			},
			// 安全綁定
			submitForm() {
				var e = true
				this.codeVftion(this.runForm.trader_password, '交易密碼')
				this.googleVftion(this.runForm.secret, 'google秘鑰')
				if (e) {
					axios.get(this.$store.state.axiosSecurityUrl, {
						params: {
							trader_password: this.runForm.trader_password,
							secret: this.runForm.secret,
							uid: this.$store.state.uid,
							action: 1,
						}
					}).then((res) => {
						// console.log(res)
						this.message = res.data.message;
						this.state = res.data.status;
						// 修改失敗
						if (!this.state) {
							if (this.state == -1) {
								this.$message({
									showClose: true,
									message: '交易密碼有誤，請重新輸入',
									type: 'error',
									duration: 1000
								});
							} else {
								this.$message({
									showClose: true,
									message: this.message,
									type: 'error',
									duration: 1000
								});
							}
						} else {
							this.payment_success = true;
							this.paymentsd = false;
							setTimeout(()=>{
								this.payment_success = false;
								this.paymentsdBD = true;
							},1000)
						}


					})

				}


			},
			// 驗證器更綁
			submitip() {
				this.codeVftion(this.trader_password_two, '交易密碼')
				this.codeVftion(this.this.code, '簡訊驗證碼')
				this.googleVftion(this.secret, 'google秘鑰')
				this.googleVftion(this.re_secret, 'google秘鑰')
				if (this.message != this.code) {
					this.$message({
						showClose: true,
						message: '簡訊驗證碼錯誤',
						type: 'error',
						duration: 1000
					});
					return
				}
				if (e) {
					axios.get(this.$store.state.axiossubmitlist, {
						params: {
							trader_password: this.trader_password_two,
							secret: this.secret,
							re_secret: this.re_secret,
							action: 1,
							uid: this.$store.state.uid,
						}
					}).then((res) => {
						// console.log(res)

						this.message = res.data.message;
						this.state = res.data.state;
						// 修改失敗
						if (this.state) {
							if (this.state == -1) {
								this.$message({
									showClose: true,
									message: '交易密碼有誤，請重新輸入',
									type: 'error',
									duration: 1000
								});
							} else {
								this.$message({
									showClose: true,
									message: this.message,
									type: 'error',
									duration: 1000
								});
							}
						} else {
							this.payment_success = true;
							this.paymentsd = false;
						}

					})
				}
			},
			// 加入安全IP
			jojnsubm() {
				if(this.ip && this.name){
					const reg =  /^(25[0-5]|2[0-4]\d|[0-1]\d{2}|[1-9]?\d)\.(25[0-5]|2[0-4]\d|[0-1]\d{2}|[1-9]?\d)\.(25[0-5]|2[0-4]\d|[0-1]\d{2}|[1-9]?\d)\.(25[0-5]|2[0-4]\d|[0-1]\d{2}|[1-9]?\d)$/;
					if(!reg.test(this.ip)){
						this.$message({
							showClose: true,
							message: '請輸入正確的IP地址',
							type: 'error',
							duration: 1000
						});
					} else {
						axios.get(this.$store.state.axiosipbind, {
							params: {
								ip: this.ip,
								name: this.name,
								action: 1,
								uid: this.$store.state.uid,
							}
						}).then((res) => {
							// console.log(res)
							this.tableData = res.data.message;
							this.state = res.data.state;

						})
					}
				}
			},
			// 分裝是否為空驗證,與純數字
			codeVftion(code, listmi) {
				if (code == '') {
					this.$message({
						showClose: true,
						message: '請輸入' + listmi,
						type: 'error',
						duration: 1000
					});
					return e = false
				} else if (this.verification(code)) {
					this.$message({
						showClose: true,
						message: listmi + '為純數字',
						type: 'error',
						duration: 1000
					});
					return e = false
				}
			},
			//驗證谷歌秘鑰,與純數字
			googleVftion(code, listmi) {
				if (code == '') {
					this.$message({
						showClose: true,
						message: '請輸入' + listmi,
						type: 'error',
						duration: 1000
					});
					return e = false
				} else if (this.vergoogletion(code)) {
					this.$message({
						showClose: true,
						message: listmi + '不符合規則',
						type: 'error',
						duration: 1000
					});
					return e = false
				}
			},
			// 限制交易密码
			verification(str) {
				var pattern = /\D/;
				if (!pattern.test(str)) {
					return false;
				} else {
					return true;
				}

			},
			// 驗證google驗證碼
			vergoogletion(str) {
				var pattern = /^[2-7A-Z]{16}$/;
				if (pattern.test(str)) {
					return false;
				} else {
					return true;
				}

			},

		},
		mounted() {
			// 讀取是否綁定谷歌驗證器
			if (this.$store.state.secretTF == -1) {
				this.secretd = '未綁定谷歌驗證器'
			} else {
				this.secretd = this.$store.state.secretd;
				this.paymentsd = false;
				this.paymentsdBD = true;
			}
			this.reserved = this.$store.state.reserved;
			// 讀取增強ip
			axios.get(this.$store.state.axiosipbind, {
				params: {
					action: 1,
					uid: this.$store.state.uid,
				}
			}).then((res) => {
				// console.log(res.data);
				this.options = res.data.message['名字'];
				this.tableData = res.data.message.數據
				this.setip = res.data.message.當前ip

			})
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	/* 交易管理》交易订单 */
	.deal_index_box {
		margin: 20px;
		font-size: 15px;
		color: black;
	}

	.deal_title {
		display: flex;
		justify-content: flex-start;

	}

	.deal_title span {
		margin-left: 15px;
		margin-right: 8px;
	}

	.deal_title .deal_hr {
		flex: 1;
		margin-left: 18px;
	}

	.deal_title .deal_hr .cut_off {
		height: 3px;
		background: black;
		margin-top: 8px;
	}

	/* 内容 */
	.datetime_box>span {
		margin: 10px;
	}

	.deal_content_box {
		font-size: 13px;
		margin-top: 20px;
	}

	.deal_content_title {
		height: 42px;
		background: #666666;
		line-height: 42px;
		color: white;
		padding-left: 14px;
	}

	.deal_content {
		box-sizing: border-box;
		/* height: 53.6vw; */
		min-height: 500px;
		border: 1px solid #666666;
		background: #ffffff;
		padding: 0 20px;
		padding-top: 26px;
	}

	.deal_content_span {
		margin-left: 23px;
		font-size: 11px;
		color: #e73262;
	}

	.deal_content_tab_first {
		width: 960px;
		margin: 0 auto;
	}

	.deal_content_tab_first>div {
		margin: 5px 0;

	}

	.money_box span {
		margin: 0 10px;
	}

	.money_input {
		width: 140px;
		/* margin-left: 4px; */
	}

	.money_input01 {
		margin-left: 4px;
	}

	.inquire_button {
		padding: 10px 0;
	}

	/* 表单 */
	.table_download {
		display: flex;
		justify-content: flex-end;
		align-items: center;
	}

	.table_download span {
		display: inline-block;
		margin: 0 10px;
	}

	/* 表单头 */
	.table_header {
		height: 36px;
		line-height: 36px;
		background: #f2f2f2;
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
	}

	.table_content {
		padding: 10px 0;
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
	}

	.table_date {
		box-sizing: border-box;
		width: 160px;
		padding-left: 14px;
		padding-right: 10px;
	}

	.table_merchantorder {
		box-sizing: border-box;
		word-break: break-all;
		word-wrap: break-word;
		width: 200px;
		padding: 0 10px;
		min-width: 160px;
	}

	.table_paymentorder {
		box-sizing: border-box;
		word-break: break-all;
		word-wrap: break-word;
		width: 200px;
		min-width: 160px;
		padding: 0 10px;
		min-width: 160px;
	}

	.table_paymenttype {
		box-sizing: border-box;
		width: 98px;
		padding: 0 10px;
		min-width: 77px;
	}

	.table_status {
		box-sizing: border-box;
		width: 100px;
		padding: 0 10px;
		min-width: 66px;
	}

	.table_money {
		box-sizing: border-box;
		width: 100px;
		padding: 0 10px;
		min-width: 66px;
	}

	/* 驗證碼綁定 */
	.list_tile_sed {
		background-color: #fff4cc;
		line-height: 40px;
		margin: 5px 20px 25px 25px;

	}

	.colro-red {
		color: #ff4a05;
		font-size: 20px;

	}

	.list_span {
		color: #e73262;
	}


	.right_col {
		padding-top: 5px;
		float: right;
		padding-right: 15px
	}

	.right_col_left {
		padding-top: 7px;
		color: #4d80e7;
		padding-left: 15px
	}

	.list_span_end {
		color: #e73262;
		padding-left: 15px;
	}

	.paind_bottm {
		padding-bottom: 80px;
	}

	.p_cetent {
		padding-top: 20px;
	}

	.p_cetent span {
		color: #13ae22;
	}

	.input_high .el-input .el-input__inner {
		height: 27px;
		border: 1px solid #cccccc;
	}

	.paind_bottm_end {
		padding-bottom: 20px;
	}

	.button_cetent {
		float: right;
		margin-top: 45px;
		padding-bottom: 25px;
	}

	.button_cetent button {
		height: 22px;
		padding-bottom: 5px;
		padding-top: 2px;
		padding-left: 8px;
		padding-right: 10px;
		width: 45px;
		font-weight: 700;
	}

	.button_cetent_seas {
		margin-left: 10px;
		padding-bottom: 25px;
	}

	.button_cetent_seas button {
		height: 27px;
		padding-bottom: 5px;
		padding-top: 2px;
		padding-left: 8px;
		padding-right: 10px;
		width: 105px;
		font-weight: 700;
	}

	.bottom_onew {
		color: #e73262;
		border-color: #e73262;
	}

	.bottom_two {
		background: #e73262;

	}

	.icon_phigt span {
		padding-left: 10px;
	}

	.div_hight_dedt {
		min-height: 330px;
		padding-top: 10px;
	}

	.bottn_warning {
		background-color: #ff771a;
		border-color: #ff771a;
		font-size: 11px;
		padding-top: 2px;
		padding-bottom: 2px;
		padding-left: 5px;
		padding-right: 5px;
		margin-bottom: 5px;
		margin-left: 10px;
	}

	.painde_top {
		padding-top: 100px;
	}

	.deal_content_tab {
		padding-left: 15%;
	}

	.list_cent {
		line-height: 40px;
	}

	#tab-second {
		padding-left: 40px;
	}

	.p_cend,
	.pid_cetent span {
		padding-top: 7px;
		color: #13ae22;
	}

	.pid_cetent {
		padding-top: 7px;
	}

	.height-plde {
		height: 1px;
	}

	.ides_onw {

		padding-bottom: 20px;
	}

	.el-form-item {
		margin-bottom: 0px;
	}

	.el-tabs__content .el-input__suffix-inner .el-input__icon {
		line-height: 25px;
	}

	.blick_deal {
		padding-top: 20px;
	}

	.delete_tab {
		color: #E73262;
		border-bottom: 1px solid #E73262;
	}
	.input_left {
		margin-left: 16px;
	}
</style>
